// extracted by mini-css-extract-plugin
module.exports = {"block":"Styles_block__1NSsm","divider":"Styles_divider__2clc_","button":"Styles_button__1aTsI"};